<div class="section-list card">
  <div class="card-header">
    <nav
      class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header nav-2rows">
      <div class="section-header">
        <div class="section-icon"><i class="fa-globe-americas fas "></i> Site</div>
        <div class="section-detail">
          <div class="section-detail-th"><i class="fa-globe-americas fas"></i> Site</div>
          <div class="section-detail-td section-detail-tit">{{site?.name}}</div>
        </div>
        <div class="section-detail" *ngIf="ui_showCompany">
          <div class="section-detail-th"><i class="fas fa-industry"></i> Company</div>
          <div class="section-detail-td" matTooltip="{{site?.company?.name}}">{{site?.company?.name}}</div>
        </div>
        <div class="section-detail">
          <div class="section-detail-th"><i class="fas fa-battery-three-quarters text-success"></i> Power</div>
          <div class="section-detail-td sm-1">{{site?.info?.power | watts:1000000}}</div>
        </div>
        <div class="section-detail" *ngIf="siteStats">
          <div class="section-detail-th"><i class="fas fa-battery-quarter text-danger"></i> Power Lost</div>
          <div class="section-detail-td sm-1">{{siteStats.powerlost | watts}}</div>
        </div>
        <div class="section-detail" *ngIf="siteStats">
          <div class="section-detail-th"><i class="fas fa-th-large text-danger"></i> Damaged modules</div>
          <div class="section-detail-td sm-1">{{siteStats.modulesinactive}}</div>
        </div>
        <div class="section-detail">
          <div class="section-detail-th">Last Modify</div>
          <div class="section-detail-td sm-1">{{site?.info?.updating_date | date:'dd-MM-yyyy HH:mm' }}</div>
        </div>
      </div>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="ml-auto d-flex justify-content-end">
          <ul class="nav navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" role="button" (click)="refresh();false">
                <i class="fas fa-sync"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
  <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
  <div class="card-body card-body-mat-tab">

    <mat-tab-group class="my-mat-tab" (selectedTabChange)="tabSelectionChanged($event)">


      <mat-tab>
        <ng-template mat-tab-label>
          <i class="far fa-edit mr-1"></i> Site Info
        </ng-template>
        <ng-template matTabContent>
          <app-site-edit #editform [site]="site" [options]="{mapVisible:true}"></app-site-edit>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fa-tachometer-alt fas mr-1"></i> DashBoard
        </ng-template>
        <ng-template [ngIf]="dashboardVisible">
          <app-site-superv [site]="site"></app-site-superv>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fas fa-map-marker-alt mr-1"></i> Map
        </ng-template>
        <!-- <ng-template matTabContent> -->
        <ng-template [ngIf]="mapVisible">
          <div style="height:90%">
            <app-ex-site-map #sitemap [site]="site"></app-ex-site-map>
          </div>

        </ng-template>
        <!-- <div *ngIf="mapVisible" class="">  -->
        <!-- <ngContainer *ngIf="mapVisible" > -->
        <!-- <app-ex-site-map #sitemap [site]="site"></app-ex-site-map> -->
        <!--   </ngContainer> -->

        <!-- </div>  -->
        <!-- </ng-template>  -->
      </mat-tab>
      <mat-tab *ngIf="site3DURL">
<!-- <iframe width="100%" height="100%" src="https://portal.geoaitech.com/austria/"></iframe>
     -->
        <ng-template mat-tab-label>
          <i class="fas fa-map-marker-alt mr-1"></i> Map 3D
        </ng-template>
        <ng-template [ngIf]="map3dVisible">
          <div style="height:75vh">
            <div class="frame3d" [innerHTML]="site3DFrame | safesanitizer: 'html'"></div>
            <!-- <iframe width="100%" height="100%" src="{{site3DURL | safesanitizer:'url'}}"></iframe> -->
          </div>

        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fa-eye far mr-1"></i> Supervisions
        </ng-template>
        <app-supervis-list [siteMode]="true" [site]="site" [showSiteCol]="false"></app-supervis-list>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fas fa-th-large mr-1"></i> Panel types
        </ng-template>
        <app-panelstype-list [site]="site"></app-panelstype-list>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <i class="fas fa-wrench mr-1"></i> Detailed Info
        </ng-template>
        <app-site-detailedinfo [site]="site"></app-site-detailedinfo>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <i class="far fa-folder mr-1"></i> Files
        </ng-template>
        <app-site-files [site]="site"></app-site-files>
      </mat-tab>
      
      <!-- <mat-tab *ngFor="let superv of supervisions">
        <ng-template mat-tab-label>
          <i class="far fa-address-book mr-1"></i> {{superv.name}}
        </ng-template>
      </mat-tab>  -->
    </mat-tab-group>
    <!--       <mat-tab>
        <ng-template mat-tab-label>
          <i class="far fa-address-book mr-1"></i> Contacts
        </ng-template>
      </mat-tab>-->





  </div>

</div>